import React from 'react';
import MainContentContainer from '../MainContentContainer';
import { colors } from '../../../utils/theme';
import Stack from '../Stack';
import Divider from '../Divider';
import MaxWidthRestrictedContent from '../MaxWidthRestrictedContent';

export type HeaderContainerOwnProps = {
    children: React.ReactNode;
    omitDivider?: boolean;
};

export type HeaderContainerProps = HeaderContainerOwnProps;

const HeaderContainer: React.FC<HeaderContainerProps> = (props) => {
    return (
        <MaxWidthRestrictedContent>
            <Stack vertical fullWidth>
                <MainContentContainer
                    style={{
                        backgroundColor: colors['White'],
                    }}
                >
                    {props.children}
                </MainContentContainer>
                {!props.omitDivider ? <Divider horizontal /> : null}
            </Stack>
        </MaxWidthRestrictedContent>
    );
};

export default React.memo(HeaderContainer);
